import api from "./api.ts";
import {
  AlertRuleQueryParams,
  AlertRulePayload,
  BatchAlertRulePayload,
  BatchUpdateAlertRulePayload,
  AlertQueryParams,
  AlertListResponse,
  AlertCountResponse,
  AlertResolveResponse,
  BatchResolveAlertPayload,
  BatchResolveAlertResponse,
} from "../types";

// 创建 Alert Rule
export const createAlertRule = async (data: AlertRulePayload) => {
  const response = await api.post("/alerts/rules", data);
  return response.data;
};

// 查询 Alert Rules
export const getAlertRules = async (params: AlertRuleQueryParams) => {
  const response = await api.get("/alerts/rules", { params });
  return response.data;
};

// 修改 Alert Rule
export const updateAlertRule = async (id: string, data: AlertRulePayload) => {
  const response = await api.put(`/alerts/rules/${id}`, data);
  return response.data;
};

// 删除 Alert Rule
export const deleteAlertRule = async (id: string) => {
  const response = await api.delete(`/alerts/rules/${id}`);
  return response.data;
};

// 批量创建 Alert Rule
export const batchCreateAlertRules = async (data: BatchAlertRulePayload) => {
  const response = await api.post("/alerts/rules/batch", data);
  return response.data;
};

// 批量更新 Alert Rule
export const batchUpdateAlertRules = async (
  data: BatchUpdateAlertRulePayload
) => {
  const response = await api.put("/alerts/rules/batch", data);
  return response.data;
};

// 获取 Alert 列表
export const getAlerts = async (
  params: AlertQueryParams
): Promise<AlertListResponse> => {
  const response = await api.get("/alerts", { params });
  return response.data;
};

// 获取 Alert 数量
export const getAlertCount = async (
  orgId: string
): Promise<AlertCountResponse> => {
  const response = await api.get("/alerts/count", { params: { orgId } });
  return response.data;
};

// 解决 Alert
export const resolveAlert = async (
  id: string
): Promise<AlertResolveResponse> => {
  const response = await api.put(`/alerts/${id}/resolve`);
  return response.data;
};

// 批量解决 Alert
export const batchResolveAlerts = async (
  data: BatchResolveAlertPayload
): Promise<BatchResolveAlertResponse> => {
  const response = await api.put("/alerts/batch/resolve", data);
  return response.data;
};

// 获取指定站点的告警列表 (使用现有的API支持siteId参数)
export const getAlertsBySite = async (
  orgId: string,
  siteId: string,
  status?: string
): Promise<AlertListResponse> => {
  const params: AlertQueryParams = {
    orgId,
    siteId, // 直接使用API的siteId参数
    status: status || "active",
    limit: "100", // Get more alerts for site view
    offset: "0",
  };

  return await getAlerts(params);
};
